(ns frontend.view.modals.custom-entity-creator.model)

;;; Separate namespace for modal-keys to avoid circular dependencies

(defonce modal-key :custom-entity-creator-modal)

(defonce opportunity-modal-key :custom-opportunity-creator)

(defonce investor-modal-key :investor-creator)
